/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { dateToInt } from '@/helpers/dateTime';
import routeList from '../../services/routeList';

export default {
  namespaced: true,
  state: {
    actualScheduleList: [],
    plannedScheduleList: [],
    routeSchedules: [],
    isLoading: false,
    isLoadingActual: false,
    showBothArrivalAndDepartureTimes: false,
  },

  mutations: {
    SET_ACTUAL_SCHEDULE_LIST(state, payload) {
      state.actualScheduleList = payload;
    },
    SET_PLANNED_SCHEDULE_LIST(state, payload) {
      state.plannedScheduleList = payload;
    },
    SET_ROUTE_SCHEDULES(state, payload) {
      state.routeSchedules = payload;
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload;
    },
    SET_LOADING_ACTUAL(state, payload) {
      state.isLoadingActual = payload;
    },
    SET_SHOW_BOTH_ARRIVAL_AND_DEPARTURE_TIMES(state, payload) {
      state.showBothArrivalAndDepartureTimes = payload;
    },
  },

  actions: {
    async getActualRouteSchedules({ commit }, { startDay, endDay } = {}) {
      try {
        // Use provided dates or default to last 30 days
        let finalStartDay = startDay;
        let finalEndDay = endDay;

        if (!finalStartDay || !finalEndDay) {
          const endDate = new Date();
          const startDate = new Date();
          startDate.setDate(startDate.getDate() - 30);
          finalStartDay = String(dateToInt(startDate));
          finalEndDay = String(dateToInt(endDate));
        }

        const params = {
          startDay: finalStartDay,
          endDay: finalEndDay,
        };

        const actualRouteSchedules = await routeList.getActualRouteSchedules(params);
        commit('SET_ACTUAL_SCHEDULE_LIST', actualRouteSchedules);
      } catch (error) {
        console.error(error);
      }
    },
    async getPlannedRouteSchedules({ commit }) {
      try {
        const plannedRouteSchedules = await routeList.getPlannedRouteSchedules();
        commit('SET_PLANNED_SCHEDULE_LIST', plannedRouteSchedules);
      } catch (error) {
        console.error(error);
      }
    },
    async fetchRouteSchedules({ dispatch, commit, state }, { startDay, endDay } = {}) {
      commit('SET_LOADING', true);
      commit('SET_LOADING_ACTUAL', true);
      try {
        await dispatch('getPlannedRouteSchedules');

        const buildCombinedSchedules = () => {
          const combinedSchedules = [];
          const routeMap = new Map();

          state.plannedScheduleList.forEach((planned, index) => {
            const { routeId } = planned.route;
            const uniqueKey = `${routeId}-${index}`;

            routeMap.set(uniqueKey, {
              planned,
              actual: null,
              stations: [],
              routeId,
            });
          });

          state.actualScheduleList.forEach((actual) => {
            const { routeId } = actual.route;

            const matchingEntry = [...routeMap.values()].find(
              (value) => value.routeId === routeId && value.actual === null,
            );

            if (matchingEntry) {
              matchingEntry.actual = actual;
            } else {
              const uniqueKey = `${routeId}-actual-${routeMap.size}`;
              routeMap.set(uniqueKey, {
                planned: null,
                actual,
                stations: [],
                routeId,
              });
            }
          });

          routeMap.forEach((value, routeId) => {
            const { planned, actual } = value;
            const stations = [];

            const plannedStations = planned?.defaultStations?.stations || [];
            const actualStations = actual?.defaultStations?.stations || [];
            const temporaryStations = planned?.temporaryStations || [];

            const actualStationsMap = new Map();
            actualStations.forEach((station) => {
              actualStationsMap.set(station.id, station);
            });

            const temporaryStationsMap = new Map();
            temporaryStations.forEach((tempSchedule) => {
              const { stations: tempStations, ...tempScheduleData } = tempSchedule;
              (tempStations || []).forEach((tempStation) => {
                if (!temporaryStationsMap.has(tempStation.id)) {
                  temporaryStationsMap.set(tempStation.id, []);
                }
                temporaryStationsMap.get(tempStation.id).push({
                  ...tempScheduleData,
                  ...tempStation,
                });
              });
            });

            plannedStations.forEach((plannedStation) => {
              const matchingActual = actualStationsMap.get(plannedStation.id);
              const matchingTemporary = temporaryStationsMap.get(plannedStation.id) || [];

              stations.push({
                ...plannedStation,
                actual: matchingActual || null,
                temporaryDefault: matchingTemporary.length > 0 ? matchingTemporary : null,
              });
            });

            value.stations = stations;
            combinedSchedules.push(value);
          });

          return combinedSchedules;
        };

        commit('SET_ROUTE_SCHEDULES', buildCombinedSchedules());
        commit('SET_LOADING', false);

        dispatch('getActualRouteSchedules', { startDay, endDay })
          .then(() => {
            commit('SET_ROUTE_SCHEDULES', buildCombinedSchedules());
            commit('SET_LOADING_ACTUAL', false);
          })
          .catch(() => {
            commit('SET_LOADING_ACTUAL', false);
          });
      } catch (error) {
        console.error('Error fetching route schedules:', error);
        commit('SET_LOADING', false);
        commit('SET_LOADING_ACTUAL', false);
      }
    },
  },

  getters: {
    actualScheduleList(state) {
      return state.actualScheduleList;
    },
    plannedScheduleList(state) {
      return state.plannedScheduleList;
    },
    routeSchedules(state) {
      return state.routeSchedules;
    },
    isLoading(state) {
      return state.isLoading;
    },
    isLoadingActual(state) {
      return state.isLoadingActual;
    },
  },
};

/* eslint-enable no-param-reassign */
/* eslint-enable no-unused-vars */
